import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { normalizeTypoPath } from "@/lib/typo-router";

/**
 * Layout for /$country/$city — renders <Outlet /> so child routes
 * (index, /$karat/$unit/$modifier) can mount.
 */
export const Route = createFileRoute("/$country/$city")({
  beforeLoad: ({ params, location }) => {
    const segmentCount = location.pathname.split("/").filter(Boolean).length;
    if (segmentCount > 2) return;

    const c = params.country.toLowerCase();
    if (c !== "pakistan" && c !== "india") {
      // Best-effort typo normalization to a PK/IN city.
      const target = normalizeTypoPath(`${params.country}/${params.city}`);
      if (target && target !== location.pathname) {
        throw redirect({ to: target, replace: true });
      }
    }
  },
  component: () => <Outlet />,
});